export default __webpack_public_path__ + "static/media/uploader-roche-2.96bde87f.png";